import { AloftPrice, isDefined, isUndefined } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import {
  CostNewByCategory,
  selectCostNewByCategory,
} from './costSelectors/selectCostNewByCategory.ts';
import { selectDepreciationRatioByCategory } from './selectDepreciationRatioByCategory.ts';

export const selectDepreciationByCategory = createSelector(
  [selectCostNewByCategory, selectDepreciationRatioByCategory],
  (costNewByCategory, depreciationRatioByCategory) => {
    if (isUndefined(costNewByCategory) || isUndefined(depreciationRatioByCategory)) {
      return {};
    }

    const mainDwellingDepreciation = AloftPrice.add(
      costNewByCategory.gla.mul(depreciationRatioByCategory.gla ?? 0),
      costNewByCategory.halfBath.mul(depreciationRatioByCategory.halfBath ?? 0),
      costNewByCategory.fullBath.mul(depreciationRatioByCategory.fullBath ?? 0),
    );

    return Object.fromEntries(
      Object.entries(costNewByCategory).reduce(
        (acc: [key: string, val: AloftPrice][], [feature, cost]) => {
          const ratio = depreciationRatioByCategory[feature as keyof CostNewByCategory];
          if (isDefined(ratio)) {
            acc.push([feature, cost.mul(ratio)]);
          }

          return acc;
        },
        [['mainDwelling', mainDwellingDepreciation]],
      ),
    );
  },
);
